import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import PezodeRangeList from "./list/PezodeRangeList";
import { ButtonToolbar } from "../../../components";
import { DisplaySpinnerContext, RouteGuardContext, TabPanelContext } from "../../../context/ContextIndex";
import PezodeRangeCreate from "./create/PezodeRangeCreate";
import { setBackDropLoader } from "../../../components-old/ComponentsIndex";

const PezodeRangeView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const _tabContextObject = useContext(TabPanelContext);
  const routeGuardContext = useContext(RouteGuardContext);
  const _tabContext = _tabContextObject.getTabFormContext();
  //const editPezodeId = _tabContext.editPezodeId;

  const spinnerCtx = useContext(DisplaySpinnerContext);
  const [showForm, setShowForm] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const pezoderange = _tabContext.data?.pezoderange ? _tabContext.data?.pezoderange.length : 0;

  const handleAddClick = () => {
    setShowForm(true);
  };

  //on cancel of create pezode range form
  const handleCancelForm = () => {
    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        selectedPezodeRange: null,
      },
    });
    setShowForm(false);
  };

  const onCancel = () => {
    try {
      navigate("/pezodelist");
    } catch (err) {
      alert(err);
    }
  };

  //on submit of pezode group
  const onPezodeRangeSubmit = (newtab = "2") => {
    try {
      _tabContextObject.setTabFormContext({
        tabIndex: newtab,
        data: {
          ..._tabContext.data
        },
        isDirty: true,
      });
    } catch (e) {
      alert(e);
    }
  };

  //on submit of replacement device form
  const handleFormSubmit = () => {
    setShowForm(false);
  };

  useEffect(() => {
    routeGuardContext.setFormState(_tabContext?.isDirty);
    setIsFormValid(_tabContext?.isDirty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showForm]);

  useEffect(() => {
    const pezoderange = _tabContext.data?.pezoderange || [];
    if (pezoderange.length > 0 && _tabContext?.isValid) {
      setIsFormValid(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_tabContext.data?.pezoderange]);

  return (
    <>
      {!showForm ? (
        <>
          {setBackDropLoader(spinnerCtx.isLoading)}
          <PezodeRangeList onAddClick={handleAddClick} setShowForm={setShowForm} setIsFormValid={setIsFormValid} />
          <ButtonToolbar
            onCancel={onCancel}
            onSubmit={onPezodeRangeSubmit}
            isFormValid={pezoderange > 0 && isFormValid}
            onSaveLabel={t("generic.next")}
            isWithAppForm={false}
          />
        </>
      ) : (
        <PezodeRangeCreate onSubmit={handleFormSubmit} onCancel={handleCancelForm} />
      )}
    </>
  );
};

export default PezodeRangeView;
